<template>
  <teleport to="body">
    <CloverPaywall
      v-if="isCloverPaywallActive"
      :is-teleported="true"
      @close-clover="closePaywall"/>
  </teleport>
  <div class="input-screen">
    <div class="toast-container">
      <div class="toast" :class="{ 'show': showToast }">{{toastMessage}}</div>
    </div>
    <Loading v-model:active="isMakeBoxProcessing"
             loader="spinner"
             color="#1E2352"
             :opacity="0"
             :z-index="999">
    </Loading>
    <TopBar
        v-if="currentIndex > 0"
        :currentIndex="currentIndex"
        :totalIndex="totalIndex"
        @exit="this.isExitPopup=true"/>
    <InputCover
        v-if="currentIndex === 0"
        :startPageImgUrl="startPageImgUrl"
        :textColor="textColor"
        @load="isLoading = false"
        @go-next="goNextPage"/>
    <InputDetails
        v-show="currentIndex > 0 && currentIndex !== totalIndex"
        :user-name="userName"
        :input-sections="inputPageMetaArr"
        :current-index="currentIndex"
        :total-index="totalIndex"
        :tarot-box-data="tarotBoxData"
        :user-birth-infos="userBirthInfos"
        :is-web="isWeb"
        @update-saju-infos="getSajuInfoList"
        @exit="this.isExitPopup=true"
        @proceed="goNextPage"
        @prev="goPreviousPage"
        @prepare="getUserAnswers"
        @warn="showWarnMessage"/>
    <TarotCardSelectPage
        v-if="isTarotBoxSelectPopup === true"
        :box-id="boxId"
        :tarot-box-data="tarotBoxData"
        @close="isTarotBoxSelectPopup = false"
        @confirm-cards="getTarotCardsString"/>
    <InputTransaction
        v-if="currentIndex === totalIndex"
        :box-id="boxId"
        :tarot-box-data="tarotBoxData"
        :is-checkout-requested="isCheckoutRequested"
        :campaign-data="campaignData"
        @checkout-web="processWebCheckout"
        @checkout-app="processAppCheckout"
        @later="outToMyTarotTab"
        @warn="showWarnMessage"/>
    <BoxPaymentPopup
        v-if="isBoxPaymentPopup === true"
        :box-id="boxId"
        :tarot-box-data="tarotBoxData"
        :user-id="userId"
        :input-data="inputData"
        :input-tarot-data="inputTarotData"
        :user-phone-number="userPhoneNumber"
        :history-id="historyId"
        :campaign-data="campaignData"
        @open-paywall="isCloverPaywallActive = true"
        @payment-done="handlePaymentDone"
        @update-user-info="getUserInfo"
        @close="isBoxPaymentPopup = false"/>
    <PaymentDonePopup
        v-if="isPaymentCompletePopup === true"/>

    <Loading v-model:active="isLoading"
             loader="dots"
             color="#1E2352"
             :opacity="1"
             :z-index="99">
      <template v-slot:default>
        <div class="custom-loader">
          <img :src="require('@/tarot_box/pages/box_result_v2/assets/main-loading/logo.svg')" alt="loader" class="loader-img"/>
          <img :src="require('@/tarot_box/pages/box_result_v2/assets/main-loading/moving.svg')" alt="moving" class="moving-svg"/>
        </div>
      </template>
    </Loading>
    <ExitPopup v-if="isExitPopup" @exit="outToMainPage" @close-popup="isExitPopup = false"/>
    </div>
</template>

<script>
import {
  changeBottomSafeAreaColor,
  changeTopSafeAreaColor,
  hideBottomBar,
  logEvent
} from "@/tarot_box/helper/native_api";
import {mapActions, mapGetters} from "vuex";
import {
  getBirthInfos,
  getTarotBoxInputDataByFetch,
  getTarotBoxItemsByFetch,
  getTarotUserInfo,
  makeBoxResult,
  purchaseBox,
  getCampaignInfo
} from "@/tarot_box/helper/mytarot_api";


import InputCover from "@/tarot_box/pages/box_input_v2/components/InputCover.vue";
import InputDetails from "@/tarot_box/pages/box_input_v2/components/InputDetails.vue";
import TopBar from "@/tarot_box/pages/box_input_v2/components/TopBar.vue";
import InputTransaction from "@/tarot_box/pages/box_input_v2/components/InputTransaction.vue";
import BoxPaymentPopup from "@/tarot_box/pages/box_input_v2/components/Popups/BoxPaymentPopup.vue";
import PaymentDonePopup from "@/tarot_box/pages/box_input_v2/components/Popups/PaymentDonePopup.vue";
import TarotCardSelectPage from "@/tarot_box/pages/box_input_v2/components/TarotCardSelect/TarotCardSelectPage.vue";
import ExitPopup from "@/tarot_box/pages/box_input_v2/components/Popups/ExitPopup.vue";
import CloverPaywall from "@/paywall/CloverPaywall";

import Loading from "vue-loading-overlay";
import {goToMyTarotTab} from "@/common/app_webview_handler";
import {remoteConfig} from "@/common/firebase";
import {snakeToCamelCase} from "@/common/utils";

export default {
  name: "InputPage.vue",
  components: {
    CloverPaywall,
    PaymentDonePopup,
    BoxPaymentPopup,
    Loading,
    InputCover,
    InputDetails,
    TopBar,
    InputTransaction,
    TarotCardSelectPage,
    ExitPopup
  },
  data() {
    return {
      language : "ko",
      isWeb: false,
      boxId: null,
      inputPageMetaArr: [],
      startPageImgUrl: "",
      textColor: '#000000',
      userName: '고객',
      userId: null,
      userPhoneNumber: null,
      userClover: 0,
      buildNumber: 0,

      inputTarotData: [],
      inputData: [],
      tarotBoxData: [],
      paymentPopupData: {},
      historyId: null,
      needTarotSpread: false,
      userBirthInfos: [],

      currentIndex: 0,
      totalIndex: 1,

      isLoading: true,
      isBoxPaymentPopup: false,
      isPaymentCompletePopup: false,
      isTarotBoxSelectPopup: false,
      isExitPopup: false,
      isCloverPaywallActive: false,

      isMakeBoxProcessing: false,
      isCheckoutRequested: false,

      showToast: false,
      toastMessage: '',

      campaignData: null,
    };
  },
  mounted() {
    hideBottomBar();
    changeTopSafeAreaColor('#FFFFFFFF');
    changeBottomSafeAreaColor('#FFFFFFFF');
    if (this.language === "") {
      this.language = "ko";
    }
    let queryParams = { ...this.$route.query };
    if (queryParams.os_type === 'web' || queryParams.os_type === 'null') {
      this.isWeb = true;
    } else {
      this.isWeb = false;
    }
    window.onBackButtonClick = this.onBackButtonClick;
    this.initiateInputPage();
    let url = new URL(decodeURIComponent(window.location.href));
    this.userId = parseInt(url.searchParams.get('tarot_user_id'));
    this.userPhoneNumber = url.searchParams.get('phone_number');
    this.buildNumber = url.searchParams.get('build_number');
    const campaignId = url.searchParams.get('campaign_id');
    if (this.buildNumber === null || this.buildNumber === undefined){
      this.buildNumber = 78;
    } else {
      this.getPaywallInfo();
    }
    if (this.userId && this.userPhoneNumber){
      this.getUserInfo(this.userId, this.userPhoneNumber);
    }
    if (campaignId) {
      this.getCampaignDetails(campaignId);
    }
  },
  beforeUnmount() {
    if (window.onBackButtonClick === this.onBackButtonClick) {
      window.onBackButtonClick = null;
    }
    this.previousSafeAreaColorTop();
    this.previousSafeAreaColorBottom();
  },
  methods: {
    ...mapActions(['setTarotBoxesData','addSafeAreaColorTop', 'addSafeAreaColorBottom', 'previousSafeAreaColorTop', 'previousSafeAreaColorBottom', 'updatePaywall']),

    onBackButtonClick() {
      return null
      // console.log('hoho')
      // const popups = {
      //   isTarotBoxSelectPopup: {action: null},  // 의도적으로 아무 동작 안 함
      //   isBoxPaymentPopup: {action: null},  // 의도적으로 아무 동작 안 함
      //   isCloverPaywallActive: {action: () => this.isCloverPaywallActive = false},
      //   isPaymentCompletePopup: {action: () => this.isPaymentCompletePopup = false},
      //   isExitPopup: {action: () => this.isExitPopup = false}
      // };
      //
      // let popupHandled = false;
      //
      // Object.entries(popups).forEach(([key, {action}]) => {
      //   if (this[key] === true) {
      //     if (action) {
      //       action();
      //       popupHandled = true;
      //     } else {
      //       console.log(`No action needed for ${key}`);
      //     }
      //   }
      // });
      //
      // // 팝업이 처리되지 않았을 경우에만 다른 동작 수행
      // if (!popupHandled) {
      //   if (this.currentIndex === 0) {
      //     this.outToMainPage();
      //   } else {
      //     this.goPreviousPage();
      //   }
      // }
    },
    async getSajuInfoList() {
      const urlParams = new URLSearchParams(window.location.search);
      const tarotUserId = urlParams.get('tarot_user_id');
      const phoneNumber = urlParams.get('phone_number');
      let res = await getBirthInfos(phoneNumber, tarotUserId);
      if (res.result === 'success'){
        this.userBirthInfos = res.data;
      }
    },
    async initiateInputPage() {
      this.boxId = parseInt(this.$route.params.boxId);
      if(this.tarotBoxes){
        this.tarotBoxData = this.tarotBoxes.find(box => box.id === this.boxId);
      } else if(this.tarotBoxes === undefined){
        let res = await getTarotBoxItemsByFetch('01032382218',121904,true)
        if (res.result === 'success'){
          this.tarotBoxData = res.data.tarot_boxes.find(box => box.id === this.boxId);
          this.setTarotBoxesData(res.data.tarot_boxes);
        }
      }
      const tarotSpread = this.tarotBoxData?.tarotSpread
      if(tarotSpread && tarotSpread.attrs.length >0){
        this.needTarotSpread = true;
      }

      let res = await getTarotBoxInputDataByFetch(this.boxId);
      if (res !== null && res !== undefined && res !=='{}') {
        console.log(res);
        this.inputPageMetaArr = res.inputSections;
        this.totalIndex = this.inputPageMetaArr.length + 1;
        this.startPageImgUrl = res.startPageImgUrl.backgroundImage;
        this.textColor = res.textColor;

        if(this.tarotBoxData){
          logEvent('boxinput_cover_into', {
            'tarot_box_id': this.tarotBoxData.id,
            'tarot_box_name': this.tarotBoxData.title,
          })
        }
      } else {
        this.toastMessage = '잠시 후 다시 시도해주세요';
        this.showToast = true;
        setTimeout(() => {
          this.$router.go(-1);
        }, 3000);
      }
      if(this.isWeb === false){
        this.getSajuInfoList()
      }
    },
    async getUserInfo(tarotUserId, phoneNumber) {
      let res = await getTarotUserInfo(tarotUserId, phoneNumber);
      if (res.result === 'success'){
        this.userName = res.data.display_name;
        this.userClover = res.data.clover_balance;
        this.isMakeBoxProcessing = false;
      }
    },
    getUserAnswers(answers) {
      this.inputData = answers;
      console.log('inputData', this.inputData)
    },
    async getPaywallInfo() {
      const configValue = remoteConfig.getValue('paywall_banner_list_v2');
      const parsedValue = JSON.parse(configValue.asString());
      console.log('parsedValue', parsedValue)
      this.updatePaywall(parsedValue);
    },
    async getCampaignDetails(campaignId) {
      let res = await getCampaignInfo(campaignId, this.boxId)
      if (res.result === 'success') {
        this.campaignData = snakeToCamelCase(res.data);
      }
    },
    async goNextPage() {
      if(this.currentIndex === 0){
        logEvent('boxinput_cover_start_click', {
          'tarot_box_id': this.tarotBoxData.id,
          'tarot_box_name': this.tarotBoxData.title,
        })
      }
      if(this.tarotBoxData && this.currentIndex < this.totalIndex && this.currentIndex > 0) {
        let sectionType = this.inputPageMetaArr[this.currentIndex -1].sectionType
      let convertedSectionType;
      if (sectionType === 'personalInfo'){
        convertedSectionType = 'myinfo';
      } else if (sectionType === 'partnerInfo'){
        convertedSectionType = 'otherinfo';
      } else if (sectionType === 'survey'){
        convertedSectionType = 'survey';
      } else {
        convertedSectionType = 'additional';
      }
        logEvent(`boxinput_${convertedSectionType}_next_click`, {
          'tarot_box_id': this.tarotBoxData.id,
          'tarot_box_name': this.tarotBoxData.title,
          'section_type': this.inputPageMetaArr[this.currentIndex - 1].sectionType
        })
      }

      if (this.currentIndex + 1 === this.totalIndex) {
        if (this.needTarotSpread === true) {
          this.isTarotBoxSelectPopup = true;
          return;
        } else {
          if ((this.tarotBoxData?.userReviews?.length ?? 0) < 3) {
            if(this.isWeb === true){
              this.goToCheckout();
            } else {
              await this.makeBoxResultForApp()
              this.isBoxPaymentPopup = true;
              return;
            }
          } else {
            if(this.isWeb === true){
              this.currentIndex++
            } else {
              await this.makeBoxResultForApp()
              this.currentIndex++
            }
          }
        }
      }
      if (this.currentIndex < this.totalIndex) {
        this.currentIndex++;
      }
    },
    goToCheckout() {
      if(this.isWeb === true){
        this.isBoxPaymentPopup = true;
        return;
      }else{
        this.processAppCheckout();
      }
    },
    async makeBoxResultForApp(){
      let pickedCards = this.inputTarotData.join(',');
      this.isMakeBoxProcessing = true;
      let res = await makeBoxResult(this.userId, this.userPhoneNumber, this.inputData, pickedCards, this.boxId);
      if(res.result === 'success'){
        this.paymentPopupData = res.data.payment_popup;
        this.historyId = res.data.id;
        console.log('historyId', this.historyId)
        this.isMakeBoxProcessing = false;
      } else{
        this.showWarnMessage('잠시 후 다시 시도해주세요');
        this.isMakeBoxProcessing = false;
      }
    },
    async processAppCheckout() {
      this.isCheckoutRequested = true;
      let userRes = await getTarotUserInfo(this.userId, this.userPhoneNumber);
      if (userRes.result === 'success'){
        this.userClover = userRes.data.clover_balance;
      } else {
        this.showWarnMessage('잠시 후 다시 시도해주세요');
      }
      if(this.historyId === null){
        await this.makeBoxResultForApp();
      }

      if (this.userClover < this.tarotBoxData.salePrice) {
        if(this.buildNumber >= 84){
          this.isCloverPaywallActive = true;
        } else{
          let dataToSend = {action: 'showPayWall'};
          window.sendInfoToApp(JSON.stringify(dataToSend));
        }
      } else {
        let res = await purchaseBox(this.userId, this.userPhoneNumber, this.historyId);
        if (res.result === 'success') {
          this.isPaymentCompletePopup = true;
          this.isCheckoutRequested = false;
        } else {
          this.showWarnMessage('잠시 후 다시 시도해주세요');
          this.isCheckoutRequested = false;
        }
      }
    },
    processWebCheckout() {
      let parsedUserInputData;
      if (typeof this.inputData === 'string'){
        try {
          parsedUserInputData = JSON.parse(this.inputData);
        } catch (error) {
          console.error('Error parsing inputData:', error);
          this.showWarnMessage('잠시 후 다시 시도해주세요');
          return;
        }
      } else {
        parsedUserInputData = this.inputData;
      }
      const userInputParams = parsedUserInputData.map(item =>
          `${item.key}=${item.value}`
      ).join('&');
      const pickedCardsParam = this.inputTarotData && this.inputTarotData.length > 0
          ? `&picked_cards=${this.inputTarotData.join(',')}`
          : '';
      const campaignParam = this.campaignData
          ? `&campaign_code=${this.campaignData.campaignCode}`
          : '';
      this.$store.dispatch('setTempInputData', parsedUserInputData)
      this.$store.dispatch('setTempCardData', pickedCardsParam)

      const url = `/tarot_box/checkout/${this.boxId}?${userInputParams}${pickedCardsParam}${campaignParam}&is_web=true`;
      this.$router.push(url);
    },
    showWarnMessage(message){
      this.toastMessage = message;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
    goPreviousPage() {
        this.currentIndex--;
    },
    outToMainPage() {
        this.$router.go(-1);
    },
    outToMyTarotTab() {
      if(this.isWeb === true){
        this.$router.go(-1);
      }else{
        goToMyTarotTab();
      }
    },
    handlePaymentDone() {
      this.isBoxPaymentPopup = false;
      this.isPaymentCompletePopup = true;
    },
    getTarotCardsString(pickedCards) {
      this.inputTarotData = pickedCards.split(',').map(Number);
      this.needTarotSpread = false;
      this.goNextPage();
      this.isTarotBoxSelectPopup = false;
    },
    async closePaywall() {
      console.log('fdsa')
      this.isMakeBoxProcessing = true;
      await this.getUserInfo(this.userId, this.userPhoneNumber);
      this.isCloverPaywallActive = false;
      this.isCheckoutRequested = false;
    }
  },
  computed: {
    ...mapGetters(['user', 'tarotBoxes']),
  }
}
</script>

<style scoped>
.input-screen {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: var(--Grayscale-Gray12);
  height: 100svh;
  width: 100vw;
  max-width: 480px;
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: scroll;
  overscroll-behavior-y: none;
  -webkit-overflow-scrolling: touch;
}

.toast-container {
  position: fixed;
  top: 250px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  z-index: 9999;
}

.toast {
  width: 65vw;
  max-width: 300px;
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--Grayscale-Gray2, #242424);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.20);
  color: var(--Grayscale-Gray12, #FFF);
  text-align: center;
  opacity: 0;
}

.toast.show {
  opacity: 1;
}

.custom-loader {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-img {
  position: absolute;
  width: 100px; /* 로고 이미지의 크기 */
  height: 100px;
}

.moving-svg {
  position: absolute;
  width: 30px; /* 움직이는 이미지의 크기 */
  height: 30px;
  animation: orbit 2s linear infinite;
}

@keyframes orbit {
  0% {
    transform: rotate(0deg) translateX(50px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(50px) rotate(-360deg);
  }
}
</style>
